import { RegisterComponent } from './register.component';
import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { RegisterCompletedComponent } from './register-completed/register-completed.component';

const registerRoutes: Routes = [
    { path: '', component: RegisterComponent },
    { path: 'completed', pathMatch: 'full', component: RegisterCompletedComponent },
];

@NgModule({
    imports: [RouterModule.forChild(registerRoutes)],
    exports: [RouterModule]
})
export class RegisterRoutingModule { }
